import { reset } from 'redux-form';

import { LINEAR_MODEL_FORM } from '../names';

export const resetLinearModelForm = () =>
  reset(LINEAR_MODEL_FORM);
